<template>
  <footer>
    <span class="reserved">{{ t('footer.copyright', { date: new Date().getFullYear() }) }}</span>
    <br />
    <span class="sitemap">
      <a :href="policy" target='_blank' class="hover:text-primary">{{ t('policies.policy') }}</a>
      <a :href="terms" target='_blank' class="hover:text-primary">{{ t('policies.terms') }}</a>
    </span>
  </footer>
</template>

<script setup>
  import { COUNTRY_TERMS, COUNTRY_POLICY } from "@u/helpers/siteData";
  import { useStore } from 'vuex';

  const { t } = useI18n();
  const store = useStore();

  const policy = computed(() => COUNTRY_POLICY.get(store.getters.language.current.cr));
  const terms = computed(() => COUNTRY_TERMS.get(store.getters.language.current.cr));
</script>

<style scoped lang="less">
  footer {
    font-size: var(--font-normal);
    .reserved {color: var(--weak-color);}
    .sitemap {font-weight: 500; color: var(--text-sub-color);}
    .sitemap a {margin-left: 10px;}
  }
</style>
